import { Injectable } from '@angular/core';

export interface ErrorReportEvent {
  message: string;
  status?: number;
  method?: string;
  url?: string;
  requestPayload?: unknown;
  responseBody?: unknown;
}

export type ErrorReportHandler = (event: ErrorReportEvent) => void;

@Injectable({ providedIn: 'root' })
export class ErrorReportService {
  private handler: ErrorReportHandler | null = null;
  private lastKey = '';
  private lastAt = 0;

  register(handler: ErrorReportHandler): () => void {
    this.handler = handler;

    return () => {
      if (this.handler === handler) {
        this.handler = null;
      }
    };
  }

  get isAvailable(): boolean {
    return this.handler !== null;
  }

  notify(event: ErrorReportEvent): boolean {
    if (!this.handler) {
      return false;
    }

    const key = `${event.method ?? ''}|${event.url ?? ''}|${event.message}`;
    const now = Date.now();

    if (key === this.lastKey && now - this.lastAt < 3000) {
      return true;
    }

    this.lastKey = key;
    this.lastAt = now;
    this.handler(event);

    return true;
  }
}
